import React from 'react'
import cx from 'classnames';
import { useTranslation } from 'react-i18next'

export default function ProgressChartLatestScore(props) {

    const { t } = useTranslation(['teacher_report_chart_progress'])

    const { shouldShowChart, embedded, small, selectedEquating, latestScore, label } = props

    if (embedded) return null
    if (!shouldShowChart) return null
    if (!latestScore) return null

    let formattedLatestScore = ` ${parseFloat(latestScore).toFixed(2)} ` + t(label);

    if(isNaN(latestScore)) formattedLatestScore = "No ARM Calculated - See WCPM"

    const latestScoreStyles = cx({
        'latestScore': true,
        'embeddedLatestScore': embedded,
        'adjustedScore': selectedEquating,
        'smallScore': small,
    });

    return <div className={latestScoreStyles}>{t(`Latest Score`)}:
        <span className="score">
            {formattedLatestScore}
        </span>
    </div>
}
